import { useState, useEffect } from 'react';

const useThrowAsyncError = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    if (error) {
      throw error;
    }
  }, [error]);
  
  return setError;
};
export default useThrowAsyncError; 